import { createUrl, request } from 'app/utils';
import { Flex, Loading, Page, Section, Typography } from 'components';
import Cards from 'features/dashboard-new/sheets/cards';
import { JourneyMonthsSubmenu, ProductJourneyDashboardLiveMeetingCalendarResponse, useJourneys } from 'features/journeys';
import { useMenu } from 'features/menu';
import { useSchool } from 'features/school';
import moment from 'moment';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';

const sanitizeMonths = (month: number, year?: number): { month: number; year: number } => {
  if (year) {
    if (month > 12) {
      return { month: 1, year: year + 1 };
    }

    return { month, year };
  }

  return { month: month > 12 ? 1 : month, year: 0 };
};

const Lives = () => {
  const [loading, setLoading] = useState(false);

  const [currentMonthIndex, setCurrentMonthIndex] = useState(0);
  const [current, setCurrent] = useState<{ month: number; year: number; monthName: string }>(undefined!);

  const { apiGatewayUrl } = useSchool();
  const { productSlug } = useParams();
  const { setJourneyCards, clearJourneyCards, journeyCards } = useJourneys();
  const { setBackPathname } = useMenu();

  const nextMonths = 12;
  const now = moment();
  const currentMonth = +now.format('M');
  const currentYear = +now.format('YYYY');

  const filters = useMemo(
    () =>
      new Array(nextMonths).fill(null).reduce(
        (prev, item, index) => {
          const { month, year } = sanitizeMonths(prev.currentMonth, prev.currentYear);

          const next = sanitizeMonths(month + 1, year);

          const current = moment(`${month}/${year}`, 'M/YYYY');

          return {
            ...prev,
            months: [...prev.months, { month, year, monthName: current.format('MMMM'), daysInMonth: current.daysInMonth() }],
            currentMonth: next.month,
            currentYear: next.year,
          };
        },
        { currentMonth, currentYear, months: [] }
      ),
    [currentMonth, currentYear]
  );

  const goToMonth = useCallback(
    (index = 0) => {
      setCurrentMonthIndex(index);
    },
    [filters]
  );

  const fetchLives = useCallback(() => {
    setLoading(true);

    request<ProductJourneyDashboardLiveMeetingCalendarResponse>({
      url: `/api/v1/School/Products/JourneyLiveMeetingCalendar/${productSlug}`,
      method: 'get',
      baseURL: apiGatewayUrl,
      params: {
        year: current?.year || undefined,
        month: current?.month || undefined,
      },
    })
      .then(({ data }) => {
        setJourneyCards(data.liveMeetings);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [productSlug, current]);

  useEffect(() => {
    setCurrent(filters.months[currentMonthIndex]);
  }, [productSlug, filters, currentMonthIndex]);

  useEffect(() => {
    setBackPathname(createUrl('journeys/details', [productSlug]));

    if (current) {
      fetchLives();
    }
  }, [productSlug, current]);

  useEffect(() => {
    return () => {
      clearJourneyCards();
    };
  }, []);

  return (
    <Page>
      {loading && <Loading alpha />}

      <Flex bg="dark_150" flexDirection="column">
        <Section flexGrow={0} pt={{ m: 6, d: 10 }} pb={{ m: 3, d: 6 }}>
          <Typography type="type8" color="white" fontWeight="bold">
            Agenda de Lives
          </Typography>

          {/* <Typography color="white" mt={3}>
          Consectetur adipiscing elit. Vivamus justo neque, laoreet at enim ut, dignissim consequat lectus. Interdum et malesuada fames ac ante ipsum
          primis in faucibus. Aenean posuere orci ac
        </Typography> */}
        </Section>

        <Flex flexGrow={0} flexDirection="column" bg="dark_400">
          <JourneyMonthsSubmenu months={filters.months} monthIndex={currentMonthIndex} onMonthClick={goToMonth} />
        </Flex>

        <Section flexDirection="column" flexGrow={0} py={{ m: 6, d: 10 }}>
          {!!journeyCards?.length ? (
            <Cards cards={journeyCards} journeyProductSlug={productSlug} />
          ) : (
            <Typography color="alert_400" fontWeight="bold">
              Nenhuma live encontrada no período selecionado.
            </Typography>
          )}
        </Section>
      </Flex>
    </Page>
  );
};

export default Lives;
